import { Injectable } from "@nestjs/common";
import { PayrollComponents } from "../entity/payroll-process.entity";
import { EntityRepository, Repository } from "typeorm";

@Injectable()
@EntityRepository(PayrollComponents)
export class PayrollProcessRepository extends Repository<PayrollComponents> {

    constructor() {
        super();
    }

 
}

